import { createAsyncThunk } from "@reduxjs/toolkit";
import { ResetPasswordBody } from "@myProfile/models";
import { ThunkApiConfig } from "@shared/models/redux";
import { openNotificationThunk } from "@store/Notification/thunks";

export const resetPasswordThunk = createAsyncThunk<boolean, ResetPasswordBody, ThunkApiConfig>(
  "myprofile/resetPasswordThunk",
  async (body, { rejectWithValue, dispatch, extra }) => {
    try {
      const response = await extra<boolean, ResetPasswordBody>(process.env.REACT_APP_AUTH_RESET_PASSWORD_URI!, {
        method: "post",
        withCredentials: false,
        body,
      });

      return response.data;
    } catch (error: any) {
      const errorMessage = error.response?.data?.[0] || "Some error occurred. Please try again.";

      dispatch(
        openNotificationThunk({
          variant: "warning",
          text: errorMessage,
        })
      );

      return rejectWithValue(errorMessage);
    }
  },
  {
    condition: (_arg, { getState }) => {
      const { loading, submitted } = getState().accountFundAccess.resetPassword;

      return !loading && !submitted;
    },
  }
);
